import React from 'react';
import platePatternUtils from "../../../../../utils/plate-pattern-utils.js";
import {FaExternalLinkAlt} from "react-icons/fa";
import InfoGrid from "../../../../../components/info-grid/info-grid.jsx";
import {navigateHook} from "../../../../../hooks/use-navigate.js";

const API_URL = import.meta.env.VITE_API_URL;

const EncounterVehicleContent = ({ vehicles, individuals, showImages, setSelectedImage, setOpenImageModal }) => {
    const navigate = navigateHook();

    return (
        <>

            { vehicles.map((vehicle, index) => {
                const attaches = vehicle?.attaches ?? [];
                const plate = vehicle?.plate;
                const relatedIndividuals = vehicle?.relatedIndividuals ?? [];

                const driver = relatedIndividuals.find((ri) => ri.relationship === "DRIVER");
                const passengers = relatedIndividuals.filter((ri) => ri.relationship === "PASSENGER");
                const driverName = individuals.find((i) => i.id === driver?.individualId)?.name ?? "";

                const passengerNames = passengers
                    .map((p) => individuals.find((i) => i.id === p.individualId)?.name)
                    .filter(Boolean)
                    .join(", ");

                const deletedAttachesCount = vehicle?.deletedAttaches?.length ?? 0;

                const info = [
                    {
                        label: "Placa",
                        value: platePatternUtils.formatPlate(vehicle?.plate) ?? "",
                        className: 'font-mono'
                    },
                    {
                        label: "Marca/Modelo",
                        value: vehicle?.brandModel ?? ""
                    },
                    {
                        label: "Tipo (Detran)",
                        value: vehicle?.type ?? ""
                    },
                    {
                        label: "Cor",
                        value: vehicle?.color ?? ""
                    },
                    {
                        label: "Ano de fabricação",
                        value: vehicle?.fabricationYear ?? ""
                    },
                    {
                        label: "Ano do modelo",
                        value: vehicle?.modelYear ?? ""
                    },
                    {
                        label: "Renavam",
                        value: vehicle?.renavam ?? ""
                    },
                    {
                        label: "Chassi",
                        value: vehicle?.chassis ?? ""
                    },
                    {
                        label: "Motor",
                        value: vehicle?.engineNumber ?? ""
                    },
                    {
                        label: "Nome do proprietário",
                        value: vehicle?.nameOwner ?? ""
                    },
                    {
                        label: "Município da placa",
                        value: vehicle?.city ?? "",
                        span: 2
                    },
                ]

                const passengersInfo = [
                    {
                        subTitle: "Envolvidos",
                        items: [
                            {
                                label: "Condutor",
                                value: driverName ?? ""
                            },
                            {
                                label: "Passageiros",
                                value: passengerNames ?? "",
                                span: 2
                            },
                        ]
                    }
                ]

                return (
                    <>

                        <section key={`vehicle-${vehicle?.id ?? plate}`}>

                            <h2 className={`flex items-center! justify-center! gap-2 w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! text-lg! text-[#4f4f4f] ${plate ? "cursor-pointer" : ""}`}
                                title={plate ? "Ver veículo" : undefined}
                                role={plate ? "button" : undefined}
                                onClick={() => {
                                    const normalizedPlate = plate?.replace(/\s/g, "").replace(/-/g, "");
                                    navigate(`/vehicle/form/${normalizedPlate}`, true);
                                }}>

                                <span className={'pl-5 print:text-[19px]!'}> {`VEÍCULO - ${index+1}`} </span> { plate && (<FaExternalLinkAlt className="text-xs print:hidden" />) }
                            </h2>

                        </section>

                        <InfoGrid title="" items={info} columns={3} labelClassName={'text-[#4F4F4F] text-[13px] print:text-[15px]!'} valueClassName={'print:text-[17px]!'} className={'px-2!'} contentClassName={'space-y-1'}/>

                        { (driverName || passengerNames) ? (
                            <InfoGrid title="" items={passengersInfo} columns={3} labelClassName={'text-[#4F4F4F] text-[13px] print:text-[15px]!'} valueClassName={'print:text-[17px]!'} className={'px-2!'} contentClassName={'space-y-1'}/>
                        ) : null}

                        { attaches?.length ? (
                            <article className={`space-y-3 px-2 ${!showImages ? 'print:hidden' : ''}`}>
                                <div className={`text-[16px] font-semibold text-[#4F4F4F]`}>
                                    Anexos
                                </div>

                                <section className="flex flex-wrap gap-3">
                                    { attaches.map((attach) => {
                                        const attachId = attach?.attachId ?? attach?.attach_id ?? attach?.id;
                                        const src = attachId ? `${API_URL}/attach/${attachId}` : "";

                                        const isDoc = attachId && attachId === vehicle?.documentAttach;
                                        const isPassage = attachId && attachId === vehicle?.passageAttach;
                                        const tagLabel = isDoc ? "Documento" : isPassage ? "Passagem" : null;

                                        return (
                                            <div key={`veh-attach-${attachId}`}>

                                                <button
                                                    type="button"
                                                    className={"w-[320px] h-[240px] rounded border border-zinc-200 cursor-pointer"}
                                                    onClick={() => {
                                                        if (!attachId) return;
                                                        setSelectedImage(src);
                                                        setOpenImageModal(true);
                                                    }}
                                                >

                                                    <img src={src} alt="Anexo" className={"w-[320px] h-[240px] object-cover"}/>

                                                </button>

                                                { tagLabel ? (
                                                    <div className="mt-1 flex justify-center print:hidden">
                                                        <span className="inline-flex items-center rounded-full bg-slate-100 px-2.5 py-1 text-xs font-medium text-slate-600">
                                                            {tagLabel}
                                                        </span>
                                                    </div>
                                                ) : null}

                                            </div>
                                        );
                                    })}

                                </section>
                            </article>
                        ) : null}

                        { deletedAttachesCount > 0 && (
                            <div className={"print:hidden italic text-center! text-xs text-[#af233a]"}>
                                {deletedAttachesCount} {deletedAttachesCount === 1 ? "anexo indisponível" : "anexos indisponíveis"} devido a um problema na coleta ou transmissão dos dados.
                            </div>
                        )}

                    </>
                );
            })}

        </>
    );
};

export default EncounterVehicleContent;